/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tab_Past_TreesInputs */

const en_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returning Trees`)
};

const ar_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأشجار العائدة`)
};

const de_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederkehrende Bäume`)
};

const es_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles de regreso`)
};

const fr_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres de retour`)
};

const it_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi di ritorno`)
};

const ja_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復刻樹木`)
};

const ko_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`돌아온 나무`)
};

const pt_br_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores de volta`)
};

const ru_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возвращающиеся деревья`)
};

const th_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ที่กลับมา`)
};

const tr_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri Dönen Ağaçlar`)
};

const zh_cn_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返场树种`)
};

const zh_tw_shop_tab_past_trees = /** @type {(inputs: Shop_Tab_Past_TreesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回歸樹種`)
};

/**
* | output |
* | --- |
* | "Returning Trees" |
*
* @param {Shop_Tab_Past_TreesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const shop_tab_past_trees = /** @type {((inputs?: Shop_Tab_Past_TreesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tab_Past_TreesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop_tab_past_trees(inputs)
	if (locale === "ar") return ar_shop_tab_past_trees(inputs)
	if (locale === "de") return de_shop_tab_past_trees(inputs)
	if (locale === "es") return es_shop_tab_past_trees(inputs)
	if (locale === "fr") return fr_shop_tab_past_trees(inputs)
	if (locale === "it") return it_shop_tab_past_trees(inputs)
	if (locale === "ja") return ja_shop_tab_past_trees(inputs)
	if (locale === "ko") return ko_shop_tab_past_trees(inputs)
	if (locale === "pt_br") return pt_br_shop_tab_past_trees(inputs)
	if (locale === "ru") return ru_shop_tab_past_trees(inputs)
	if (locale === "th") return th_shop_tab_past_trees(inputs)
	if (locale === "tr") return tr_shop_tab_past_trees(inputs)
	if (locale === "zh_cn") return zh_cn_shop_tab_past_trees(inputs)
	return zh_tw_shop_tab_past_trees(inputs)
});